// import { UserDataT } from "@/types/auth";
import { create } from "zustand";
import Axios from "../lib/Axios";

const useInterestGroupStore = create((set) => ({
  groupInterest: [],
  groupInterestSelectCompatiable: [],
  fetchInterestGroup: async () => {
    try {
      const result = await Axios.post("cms/cms-get/interest-group-names");

      const data = result?.data?.result?.results?.map((item) => {
        return { label: item.groupName, value: item.groupId, ...item };
      });

      set((state) => ({
        groupInterest: result?.data?.result?.results,
        groupInterestSelectCompatiable: data,
      }));
    } catch (error) {}
  },
}));

export default useInterestGroupStore;
